module.exports = __webpack_public_path__ + "media/images/covers/cover-4-fee030baa2d72d4a139cc48e159f3d6e.jpg";